import { TextBase } from '@carboncopyco/ui';

interface DiagnosticErrorProps {
  errors: string[];
}
export const DiagnosticErrorsSection = ({ errors }: DiagnosticErrorProps) => {
  return (
    <div className="w-full h-full overflow-y-auto bg-ds-natural-50">
      <div className="flex flex-col pl-5 gap-2.5 mt-2.5">
        {errors.map((error) => (
          <TextBase
            label={error}
            key={error.trim()}
            color="text-ds-danger-500"
          />
        ))}
      </div>
    </div>
  );
};
